// =============================================================================
// usePlanGate Hook - Plan gating for UI components
// =============================================================================

import { useAuthStore } from '@/stores/auth';

export function usePlanGate() {
  const { organization } = useAuthStore();
  const billing = organization?.billing;

  const plan = billing?.plan || 'FREE';
  const status = billing?.status || 'ACTIVE';

  const isTrialing = status === 'TRIALING' && !!billing?.trialEnd && new Date(billing.trialEnd) > new Date();
  const trialExpired = status === 'TRIALING' && !!billing?.trialEnd && new Date(billing.trialEnd) <= new Date();
  const isPro = plan === 'PRO' && (status === 'ACTIVE' || status === 'PAST_DUE');
  const isFree = plan === 'FREE' || trialExpired || status === 'CANCELED';

  // Cancel pending = still has Pro access but cancellation scheduled
  const cancelPending = plan === 'PRO' && billing?.cancelAtPeriodEnd === true && status === 'ACTIVE';

  const currentPeriodEnd = billing?.currentPeriodEnd;

  const canCreateProperty = isPro || isTrialing;
  const canUseDocuSign = isPro || isTrialing;
  const canUploadDocuments = isPro || isTrialing;

  const trialDaysRemaining = isTrialing && billing?.trialEnd
    ? Math.max(0, Math.ceil((new Date(billing.trialEnd).getTime() - Date.now()) / (1000 * 60 * 60 * 24)))
    : 0;

  return {
    plan,
    status,
    isPro,
    isTrialing,
    isFree,
    trialExpired,
    cancelPending,
    currentPeriodEnd,
    canCreateProperty,
    canUseDocuSign,
    canUploadDocuments,
    trialDaysRemaining,
  };
}
